// extracted by mini-css-extract-plugin
export var group = "OurPeopleDetails-module--group--90779";
export var groupwrapper = "OurPeopleDetails-module--groupwrapper--7852e";
export var subGroup = "OurPeopleDetails-module--subGroup--6fc4e";
export var subGroupDetails = "OurPeopleDetails-module--subGroupDetails--98f32";
export var subGroupDetailsPhone = "OurPeopleDetails-module--subGroupDetailsPhone--05166";